import {
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    Tooltip,
    Typography,
} from '@mui/material';
import './pages-contents.table.scss';
import LinearProgress from '@mui/material/LinearProgress';
import { PagesPaginationDto } from '../../../../services/dtos/pages-pagination.dto';
import { Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { StyledTableRow } from '../../../commun/table-row';

/**
 * Composant du tableau des pages
 * @constructor
 */
export default function PagesContentsTable(props: {
    pages?: PagesPaginationDto | null;
    isSearching: boolean;
    handleSwitchPageNumber(newPage: number): void;
    page: number;
    rowsPerPage: number;
}) {
    const navigate = useNavigate();

    // En-têtes des cellules du tableau
    const headCells = [
        {
            id: 'page.id',
            label: 'Identifiant',
            sort: false,
        },
        {
            id: 'facture.codePage',
            label: 'Nom page',
            sort: false,
        },
        {
            id: 'facture.codeChamps',
            label: 'Nom élement',
            sort: false,
        },
        {
            id: 'actions',
            label: '',
            sort: false,
        },
    ];

    /**
     * Gestion du changement de page, avec la récupération d'une autre page de factures
     * @param event Événement
     * @param newPage Page à afficher
     */
    const handleOnPageChange = async (event: any, newPage: number) => {
        event.preventDefault();
        props.handleSwitchPageNumber(newPage);
    };

    return (
        <TableContainer className={'containerPages'} component={Paper} sx={{ padding: '20px' }}>
            {/*Affichage des infos du contrat*/}
            <Typography variant={'h5'}>Liste des pages paramétrées.</Typography>
            {/*// Affichage du tableau*/}
            <Table>
                <TableHead>
                    <TableRow>
                        {/*En-têtes*/}
                        {headCells.map(headCell => (
                            <TableCell key={headCell.id} align={'left'} sx={{ fontWeight: 'bold', fontSize: 'medium' }}>
                                {headCell.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                {/* Gestion du chargement des pages/tri avec une progress bar */}
                <TableBody>
                    {!props.isSearching ? (
                        // Lignes du tableau
                        props.pages?.pages?.map(row => (
                            <StyledTableRow key={row.id}>
                                <TableCell>{row.id}</TableCell>
                                <TableCell>{row.codePage}</TableCell>
                                <TableCell>{row.codeChamps}</TableCell>
                                <TableCell>
                                    <Tooltip title={'Éditer le contenu'} arrow>
                                        <IconButton onClick={() => navigate(`/administration/pages/${row.id}`)}>
                                            <Edit />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </StyledTableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={headCells.length}>
                                <LinearProgress />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                <TableFooter>
                    <TableRow>
                        {/*Options de pagination*/}
                        <TablePagination
                            count={props.pages?.totalItems ? props.pages?.totalItems : 0}
                            onPageChange={handleOnPageChange}
                            page={props.page}
                            rowsPerPage={props.rowsPerPage}
                            rowsPerPageOptions={[props.rowsPerPage]}
                            labelDisplayedRows={({ from, to, count }) => `${from} à ${to} sur ${count}`}
                            showFirstButton
                            showLastButton
                        />
                    </TableRow>
                </TableFooter>
            </Table>
        </TableContainer>
    );
}
